import i18n from 'i18next';
import { AccountSwitchProps } from '@common/types/types';

export const getAccountOptions = (): AccountSwitchProps[] => [
  // {
  //   label: i18n.t('nav:businessAccount.title'),
  //   field: 'isWebsiteOwner',
  //   description: i18n.t('nav:businessAccount.description'),
  // },
  // {
  //   label: i18n.t('nav:personalAccount.title'),
  //   field: 'isWidgetUser',
  //   description: i18n.t('nav:personalAccount.description'),
  // },
];
